import React from 'react';
import ShareManagement from '@/components/shareManagement';

const ShareManagementPage: React.FC = () => {
  return <ShareManagement />;
};

export default ShareManagementPage;
